import { Accordion as BaseUiAccordion } from '@base-ui-components/react/accordion';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '#/ui/utils/types';

export interface AccordionDetailsProps extends React.PropsWithChildren<CommonProps> {
  disableGutter?: boolean;
}

// @todo fix text-content-secondary

function AccordionDetails({ children, className, disableGutter = false }: AccordionDetailsProps) {
  return (
    <BaseUiAccordion.Panel
      className={twMerge(
        'gooey-accordion-details',
        'h-[var(--accordion-panel-height)] overflow-hidden text-base transition-[height] ease-out data-[ending-style]:h-0 data-[starting-style]:h-0',
        className
      )}
    >
      <div className={twMerge(!disableGutter && 'pt-2 pb-4')}>{children}</div>
    </BaseUiAccordion.Panel>
  );
}
AccordionDetails.display = 'GooeyAccordionDetails';

export default AccordionDetails;
